/* KS Sticky Cart Bar (CVR-007/008/009)
 *
 * Shows only when eligible 台美直郵 products are in cart.
 * Reads live eligibility from #ks-free-shipping-progress-slot (ks-cart-progress.js).
 */
(function () {
  if (window.__ksStickyCartBar) return;
  window.__ksStickyCartBar = true;

  var SLOT_SELECTOR = '#ks-free-shipping-progress-slot';
  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  var ATC_COUNT_KEY = 'ks-sticky-atc-count';
  var EXPAND_SHOWN_KEY = 'ks-sticky-expand-shown';
  var TOAST_MS = 2600;
  var EXPAND_MS = 5000;

  var bar = document.querySelector('[data-ks-sticky-cart-bar]');
  if (!bar) return;

  var els = {
    inner: bar.querySelector('[data-ks-bar-inner]'),
    fill: bar.querySelector('[data-ks-bar-fill]'),
    progress: bar.querySelector('[data-ks-progress]'),
    count: bar.querySelector('[data-ks-count]'),
    summary: bar.querySelector('[data-ks-summary]'),
    hintMain: bar.querySelector('[data-ks-hint-main]'),
    hintScope: bar.querySelector('[data-ks-hint-scope]'),
    cta: bar.querySelector('[data-ks-cta]'),
    ctaDesktop: bar.querySelector('[data-ks-cta-desktop]'),
    ctaTextMobile: bar.querySelector('[data-ks-cta-text-mobile]'),
    ctaTextDesktop: bar.querySelector('[data-ks-cta-text-desktop]'),
    viewCart: bar.querySelector('[data-ks-view-cart]'),
    openDrawer: bar.querySelector('[data-ks-open-drawer]'),
    openDrawerText: bar.querySelector('[data-ks-open-drawer-text]'),
    toast: bar.querySelector('[data-ks-toast]'),
    toastText: bar.querySelector('[data-ks-toast-text]'),
    expand: bar.querySelector('[data-ks-expand]'),
    expandText: bar.querySelector('[data-ks-expand-text]'),
    expandCta: bar.querySelector('[data-ks-expand-cta]'),
  };

  var copy = {
    titleBelow: bar.dataset.copyTitleBelow || '',
    shippingBelow: bar.dataset.copyShippingBelow || '',
    titleSuccess: bar.dataset.copyTitleSuccess || '',
    messageSuccess: bar.dataset.copyMessageSuccess || '',
    eligibleNote: bar.dataset.copyEligibleNote || '',
    viewCart: bar.dataset.copyViewCart || '查看購物車',
    checkoutDesktop: bar.dataset.copyCheckoutDesktop || '前往結帳',
    checkoutMobile: bar.dataset.copyCheckoutMobile || '結帳',
    progressAria: bar.dataset.copyProgressAria || '台美直郵指定商品運費優惠進度',
    ncBelow: bar.dataset.copyNcBelow || '第一單免運・整筆訂單再加 [nc_remaining]，運費 $0',
    ncSuccess: bar.dataset.copyNcSuccess || '第一單免運・結帳運費 $0',
    ncOnlyTitle: bar.dataset.copyNcOnlyTitle || '整筆訂單 [nc_count] 件・[nc_subtotal] / [nc_threshold]',
    ncOnlyTitleSuccess: bar.dataset.copyNcOnlyTitleSuccess || '整筆訂單 [nc_count] 件・[nc_subtotal]',
    ncOnlyBelow: bar.dataset.copyNcOnlyBelow || '第一單免運・再加 [nc_remaining]，運費 $0',
  };

  var drawerOpen = false;
  var impressionSent = false;
  var currentMode = 'hidden';
  var toastTimer = null;
  var expandTimer = null;
  var lastEligibleTotal = 0;

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    var hasCents = Math.round(cents) % 100 !== 0;

    return (
      '$' +
      value.toLocaleString(undefined, {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2,
      })
    );
  }

  function formatMoneyCeil(cents) {
    return '$' + Math.ceil(Number(cents || 0) / 100).toLocaleString();
  }

  function applyCopyTemplate(template, vars) {
    if (!template) return '';
    // Defensive: the new-customer line passes only [nc_remaining], so every
    // token has to survive a vars object that doesn't carry the campaign numbers.
    vars = vars || {};

    return template
      .replace(/\[count\]/g, vars.count == null ? '' : vars.count)
      .replace(/\[subtotal\]/g, vars.subtotal == null ? '' : formatMoney(vars.subtotal))
      .replace(/\[threshold\]/g, vars.threshold == null ? '' : formatMoney(vars.threshold))
      .replace(/\[remaining\]/g, vars.remaining == null ? '' : formatMoneyCeil(vars.remaining))
      .replace(/\[nc_remaining\]/g, vars.nc_remaining == null ? '' : vars.nc_remaining)
      .replace(/\[nc_count\]/g, vars.nc_count == null ? '' : vars.nc_count)
      .replace(/\[nc_subtotal\]/g, vars.nc_subtotal == null ? '' : formatMoney(vars.nc_subtotal))
      .replace(/\[nc_threshold\]/g, vars.nc_threshold == null ? '' : formatMoney(vars.nc_threshold))
      .replace(/\[eligible_collections\]/g, vars.eligibleCollections || '');
  }

  function buildCopyVars(data) {
    return {
      count: String(data.eligibleCount),
      subtotal: data.eligibleTotal,
      threshold: data.minimumThreshold,
      remaining: Math.max(0, data.minimumThreshold - data.eligibleTotal),
      eligibleCollections: data.eligibleCollections || '',
    };
  }

  function track(eventName, extra) {
    var payload = { cart_value: lastEligibleTotal / 100 };
    if (extra) {
      for (var key in extra) payload[key] = extra[key];
    }

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (_e) { /* tracking must never break the bar */ }

    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
      }
    } catch (_e) { /* noop */ }

    try {
      window.dataLayer = window.dataLayer || [];
      var entry = { event: eventName };
      for (var key in payload) entry[key] = payload[key];
      window.dataLayer.push(entry);
    } catch (_e) {
      /* tracking must never break the bar */
    }
  }

  function getSlot() {
    return document.querySelector(SLOT_SELECTOR);
  }

  function getCampaignData() {
    if (bar.dataset.stickyEnabled === 'false') return null;

    var slot = getSlot();
    var eligibleCount = Number(bar.dataset.eligibleCount || 0);
    var eligibleTotal = Number(bar.dataset.eligibleTotal || 0);
    var minimumThreshold = Number(bar.dataset.minimumThreshold || 9900);
    var eligibleCollections = bar.dataset.eligibleCollections || '';

    if (slot) {
      var state = slot.dataset.ksState;
      if (!state || state === 'empty') return null;

      eligibleCount = Number(slot.dataset.ksEligibleCount || eligibleCount);
      eligibleTotal = Number(slot.dataset.ksEligibleTotal || eligibleTotal);
      minimumThreshold = Number(slot.dataset.ksMinimumThreshold || minimumThreshold);
      eligibleCollections = slot.dataset.ksEligibleCollections || eligibleCollections;
    } else if (eligibleCount <= 0) {
      return null;
    }

    return {
      eligibleCount: eligibleCount,
      eligibleTotal: eligibleTotal,
      minimumThreshold: minimumThreshold,
      eligibleCollections: eligibleCollections,
    };
  }

  /* 新客首單免運。基數是**整筆訂單**，跟這條 bar 其他數字（台美直郵商品小計）
     不同口徑，所以文案一定要自己講「整筆訂單」，不能混進 [remaining] 那一組變數。
     數字由 ks-free-shipping-progress.liquid 掛在 slot 上、
     ks-cart-progress.js 每次刷新時搬過來，這裡只讀不算。 */
  function getNewCustomer() {
    var slot = getSlot();
    if (!slot || slot.dataset.ksNc !== '1') return null;
    var min = Number(slot.dataset.ksNcMin || 0);
    if (min <= 0) return null;
    return {
      min: min,
      gap: Number(slot.dataset.ksNcGap || 0),
      orderTotal: Number(slot.dataset.ksNcOrderTotal || 0),
      itemCount: Number(slot.dataset.ksNcItemCount || 0),
    };
  }

  function formatScopeNote(text) {
    if (!text) return '';
    var trimmed = text.trim();
    if (!trimmed) return '';
    return trimmed.indexOf('ⓘ') === 0 ? trimmed : 'ⓘ ' + trimmed;
  }

  function updateCheckoutLabels() {
    if (els.ctaTextMobile) els.ctaTextMobile.textContent = copy.checkoutMobile;
    if (els.ctaTextDesktop) els.ctaTextDesktop.textContent = copy.checkoutDesktop;
    if (els.viewCart) els.viewCart.textContent = copy.viewCart;
    if (els.progress) els.progress.setAttribute('aria-label', copy.progressAria);
  }

  function render() {
    var data = getCampaignData();
    var nc = getNewCustomer();

    /* 「只有新客」模式：車上沒有任何台美直郵商品，但這位是有碼的新客。
       以前這種車整條 bar 都不出現，等於把唯一還在跑的門檻藏起來。
       這個模式下整條 bar（摘要、進度條、提示）都改講**整筆訂單**——
       一次只講一個基數，就不會有兩個 $99 打架的問題。 */
    var ncOnly = !!(nc && nc.itemCount > 0 && (!data || data.eligibleCount <= 0));

    if (!ncOnly && (!data || data.eligibleCount <= 0)) {
      bar.classList.add('is-hidden');
      document.body.classList.remove('ks-sticky-bar-visible');
      currentMode = 'hidden';
      return;
    }

    lastEligibleTotal = ncOnly ? nc.orderTotal : data.eligibleTotal;
    bar.classList.remove('is-hidden');
    if (!drawerOpen) document.body.classList.add('ks-sticky-bar-visible');

    var vars = data ? buildCopyVars(data) : {};
    var success = ncOnly
      ? nc.gap <= 0
      : (data.minimumThreshold > 0 && data.eligibleTotal >= data.minimumThreshold);

    currentMode = ncOnly
      ? (success ? 'new_customer_only_success' : 'new_customer_only')
      : (success ? 'success' : 'below_threshold');

    if (ncOnly) {
      vars.nc_count = String(nc.itemCount);
      vars.nc_subtotal = nc.orderTotal;
      vars.nc_threshold = nc.min;
    }
    if (nc) vars.nc_remaining = formatMoneyCeil(nc.gap);

    els.count.textContent = ncOnly ? String(nc.itemCount) : vars.count;
    els.summary.textContent = applyCopyTemplate(
      ncOnly
        ? (success ? copy.ncOnlyTitleSuccess : copy.ncOnlyTitle)
        : (success ? copy.titleSuccess : copy.titleBelow),
      vars
    );

    if (els.hintMain) {
      /* 新客手上有碼時，$0 完勝 $10——就別再講「國際運費降至 $10」了，
         那是把比較差的優惠推到前面。
         有直郵商品時摘要列是直郵口徑，所以提示得自己標明「整筆訂單」；
         ncOnly 時摘要列本身就是整筆訂單，再寫一次只是重複。 */
      var ncText = '';

      if (ncOnly) {
        ncText = nc.gap <= 0 ? copy.ncSuccess : applyCopyTemplate(copy.ncOnlyBelow, vars);
      } else if (nc) {
        ncText = nc.gap <= 0 ? copy.ncSuccess : applyCopyTemplate(copy.ncBelow, vars);
      }

      els.hintMain.textContent = ncText || applyCopyTemplate(
        success ? copy.messageSuccess : copy.shippingBelow,
        vars
      );
      els.hintMain.hidden = false;
      bar.classList.toggle('is-new-customer', !!ncText);
    }

    if (els.hintScope) {
      /* ⚠️ ncOnly 時一定要收起來：「不含現貨／海運團商品」是台美直郵活動的但書，
         新客碼算的是整筆訂單，照抄會變成錯的。 */
      var scopeText = ncOnly ? '' : applyCopyTemplate(copy.eligibleNote, vars);
      if (scopeText) {
        els.hintScope.textContent = formatScopeNote(scopeText);
        els.hintScope.hidden = false;
      } else {
        els.hintScope.hidden = true;
      }
    }

    var progressBase = ncOnly ? nc.min : data.minimumThreshold;
    var progressNow = ncOnly ? nc.orderTotal : data.eligibleTotal;
    var progressPercent = progressBase > 0
      ? Math.min(100, Math.round((progressNow * 100) / progressBase))
      : 0;

    if (success) progressPercent = 100;

    if (els.fill) {
      els.fill.style.width = progressPercent + '%';
    }

    if (els.progress) {
      var thresholdDollars = Math.round(progressBase / 100);
      var nowDollars = Math.min(thresholdDollars, Math.round(progressNow / 100));
      els.progress.setAttribute('aria-valuemax', String(thresholdDollars));
      els.progress.setAttribute('aria-valuenow', String(nowDollars));
    }

    bar.classList.toggle('is-success', success);
    updateCheckoutLabels();

    if (!impressionSent) {
      impressionSent = true;
      track('ks_sticky_bar_impression', { bar_state: currentMode });
    }
  }

  function pulse() {
    if (!els.inner) return;
    els.inner.classList.remove('is-updated');
    void els.inner.offsetWidth;
    els.inner.classList.add('is-updated');
  }

  function showToast() {
    if (!els.toast || drawerOpen) return;
    if (currentMode === 'hidden') return;

    var hint = els.hintMain ? (els.hintMain.textContent || '').trim() : '';
    els.toastText.textContent = hint ? '已加入購物車｜' + hint : '已加入購物車';

    els.toast.hidden = false;
    void els.toast.offsetWidth;
    els.toast.classList.add('is-visible');
    track('ks_sticky_toast_shown', { bar_state: currentMode });

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      els.toast.classList.remove('is-visible');
      window.setTimeout(function () {
        els.toast.hidden = true;
      }, 260);
    }, TOAST_MS);
  }

  function maybeShowExpand() {
    if (!els.expand) return;
    if (currentMode === 'hidden') return;
    if (window.location.pathname.indexOf('/collections/') === -1) return;
    if (sessionStorage.getItem(EXPAND_SHOWN_KEY) === 'true') return;

    var atcCount = Number(sessionStorage.getItem(ATC_COUNT_KEY) || 0);
    if (atcCount !== 2) return;

    sessionStorage.setItem(EXPAND_SHOWN_KEY, 'true');

    var data = getCampaignData();
    if (!data) return;

    var vars = buildCopyVars(data);
    var success =
      data.minimumThreshold > 0 && data.eligibleTotal >= data.minimumThreshold;

    if (!success) {
      els.expandText.textContent =
        applyCopyTemplate(copy.shippingBelow, vars) + '，這些最多人一起帶';
      els.expandCta.textContent = '繼續選購';
    } else {
      els.expandText.textContent = '商品都幫你留好了，隨時可以結帳';
      els.expandCta.textContent = copy.checkoutDesktop;
    }

    els.expand.hidden = false;
    track('ks_sticky_expand_shown', { bar_state: currentMode });

    window.clearTimeout(expandTimer);
    expandTimer = window.setTimeout(hideExpand, EXPAND_MS);
  }

  function hideExpand() {
    if (els.expand) els.expand.hidden = true;
  }

  function openDrawer() {
    hideExpand();
    document.dispatchEvent(
      new CustomEvent('theme:cart:toggle', {
        bubbles: true,
        detail: { isOpen: true },
      })
    );
  }

  function onCtaClick(event) {
    track('ks_sticky_bar_cta_click', {
      bar_state: currentMode,
      cta_action: 'checkout',
    });

    window.location.href =
      (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
  }

  function onProductAdded() {
    var count = Number(sessionStorage.getItem(ATC_COUNT_KEY) || 0) + 1;
    sessionStorage.setItem(ATC_COUNT_KEY, String(count));

    pulse();

    window.setTimeout(function () {
      render();
      showToast();
      maybeShowExpand();
    }, 700);
  }

  function bindDrawerTrigger(el, action) {
    if (!el) return;
    el.addEventListener('click', function () {
      track('ks_sticky_bar_cta_click', { bar_state: currentMode, cta_action: action });
      openDrawer();
    });
  }

  bindDrawerTrigger(els.openDrawer, 'icon-drawer');
  bindDrawerTrigger(els.openDrawerText, 'info-drawer');

  if (els.cta) els.cta.addEventListener('click', onCtaClick);
  if (els.ctaDesktop) els.ctaDesktop.addEventListener('click', onCtaClick);

  if (els.expandCta) {
    els.expandCta.addEventListener('click', function () {
      track('ks_sticky_expand_cta_click', { bar_state: currentMode });
      if (currentMode === 'below_threshold') {
        openDrawer();
      } else {
        window.location.href =
          (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      }
    });
  }

  if (els.viewCart) {
    els.viewCart.addEventListener('click', function (event) {
      event.preventDefault();
      track('ks_sticky_bar_cta_click', { bar_state: currentMode, cta_action: 'view-cart' });
      openDrawer();
    });
  }

  document.addEventListener('theme:product:added', onProductAdded);

  document.addEventListener('ks:cart-state:updated', function () {
    render();
  });

  document.addEventListener('theme:cart-drawer:open', function () {
    drawerOpen = true;
    bar.classList.add('is-drawer-open');
    document.body.classList.remove('ks-sticky-bar-visible');
    hideExpand();
  });

  document.addEventListener('theme:cart-drawer:close', function () {
    drawerOpen = false;
    bar.classList.remove('is-drawer-open');
    render();
  });

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', updateCheckoutLabels);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(updateCheckoutLabels);
  }

  render();
})();
